import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import outback from "../../../../assets/info/outback-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import part1 from "../../../../assets/info/subaru-outback/subaru-outback-fig-1.jpg";
import styled from "styled-components";
import { popularVehicle } from "../../../../vars/popularVehicles";

const SubaruOutback = () => {
  useSmallNav("Subaru Outback");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Subaru Outback"} bolder />
        <InfoHero image={outback} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Czy otrzymałeś ostatnio wycenę tylnego samopoziomującego zawieszenia Subaru Outback?"
              }
            />
            <p>
              Jeśli ostatnio miałeś wycenę Subaru, wiesz, jak drogie są zamienne
              tylne amortyzatory samopoziomujące! Zawieszenie Pedders ma
              ekonomiczne rozwiązanie Twoich problemów. Oferujemy zamienny
              zestaw sprężyn i amortyzatorów do tylnej części Twojego Outbacka,
              który wyeliminuje kłopotliwy układ samopoziomowania. Osiąga się to
              poprzez zainstalowanie konwencjonalnego amortyzatora tylnego i
              sprężyny zaprojektowanych do tego zastosowania.
            </p>
            <p>
              Zestaw stanowi bezpośrednią śrubę zastępczą. Nie są wymagane żadne
              modyfikacje pojazdu. Nie są wymagane żadne dodatkowe części.
              Podczas montażu konieczne będzie ponowne użycie oryginalnego
              układu mocowania górnego. Do wykonania tego zadania potrzebne będą
              ściągacze sprężynowe.
            </p>
            <p>
              Czy mój pojazd naprawdę powróci do pierwotnej wysokości jazdy?
              Tak, zdecydowanie! Istnieje wiele przykładów sytuacji, w których w
              Outbackach zastąpiono samopoziomujące amortyzatory
              konwencjonalnymi amortyzatorami, które następnie są zbyt nisko
              osadzone. Dzieje się tak dlatego, że oryginalna sprężyna nie jest
              zaprojektowana tak, aby samodzielnie utrzymać cały ciężar
              samochodu, gdyż zwykle wspomaga ją amortyzator samopoziomujący.
            </p>
            <p>
              Firma Pedders Suspension przezwycięża ten problem, dostarczając
              dopasowany zestaw amortyzatorów i sprężyn specjalnie do tego celu.
              Możesz kupić z całkowitą pewnością, że pojazd będzie miał
              odpowiednią wysokość, a kłopotliwe i drogie amortyzatory
              samopoziomujące przejdą do historii.
            </p>
            <p>
              Jeśli zależy Ci na sportowym wyglądzie i chciałbyś obniżyć swojego
              Outbacka, oferujemy również obniżoną sprężynę. Zalecamy obniżenie
              tyłu pojazdu w połączeniu z obniżeniem przedniego zawieszenia w
              celu dopasowania.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              title={"Subaru Outback Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Subaru Outback Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Subaru")
              .models.find((e) => e.display === "Outback")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <Gray>
              <div>
                <StyledImgParts src={part1} alt="Outback Suspension Kits" />
              </div>
            </Gray>
          </div>
        </InfoGrid>
      </Container>
    </section>
  );
};

export default SubaruOutback;

const StyledImgParts = styled.img`
  width: 100%;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
